import React, { useCallback } from 'react';

import { CartActions, ECartActions, IUpdateGiftPackagingAction } from '../model';

export const useUpdateGiftPackaging = (dispatch: React.Dispatch<CartActions>) => {
  return useCallback(
    (data: IUpdateGiftPackagingAction) => {
      if (data) {
        dispatch({
          actionType: ECartActions.TOGGLE_GIFT_PACKAGING,
          payload: {
            pricesSummary: data.pricesSummary,
            giftPackagings: data.giftPackagings,
          },
        });
      }
    },
    [dispatch],
  );
};
